import { mdiClipboardAccountOutline } from '@mdi/js'

export default {
  title: 'Greeting',
  to: 'greeting-list',
  icon: mdiClipboardAccountOutline,
  resource: 'GreetingSchool',
  action: 'read',
}
